// types
import {
  FIRST_COMPANY_ID,
  SET_USER_COMPANY,
  SET_USER_DETAILS,
  SET_USER_STATUS,
  SET_USER_VERIFICATION,
  SetUserTypes,
  USER_COMPANIES,
  USER_PHONES,
  USER_UPDATE_ERRORS,
  SET_AVATAR_UPLOADING,
  REFRESH_AVATAR,
  SET_USER_PHONE_DETAILS,
  SET_USER_FEATURE_FLAGS,
  SET_USER_FEATURE_FLAGS_STATUS,
  SET_COMPANY_EMPLOYEE_ROLES,
  SET_COMPANY_ROLES,
  // hardcoded special changes
  SET_HIDE_DELETE_BUTTON,
  SET_CHANGE_PROJECT_COLUMNS,
  SET_ONLY_SHOW_MY_PROJECTS,
  SET_ALLOW_COMPANY_WIDE_EDIT_NOTES,
} from 'Containers/User/actions';

// state
const initialState = {
  user: {},
  userStatus: '',
  userPhones: {},
  userCompanies: {},
  firstCompanyId: '',
  userCompany: {},
  userVerifications: {
    authenticated: false,
    sms: false,
    company: false,
    approved: false,
    isNew: false,
  },
  avatarUploading: false,
  refreshAvatar: false,
  userPhoneDetails: {},
  userFeatureFlagsFetched: false,
  userFeatureFlagsStatus: 'idle',
  userFeatureFlags: {
    companyApprove: false,
    rocketscanDamages: false,
    projectLossInfo: false,
    rocketReports: false,
    rocketDryReports: false,
    timeTracking: false,
    customReports: false,
    eSignature: false,
    rocketPay: false,
    rocketScope: true,
    secondaryCompany: false,
    serializedEquipment: false,
    // hardcoded special changes
    hideDeleteButton: false,
    changeProjectColumns: false,
    onlyShowMyProjects: false,
    allowCompanyWideEditNotes: true,
  },
  companyEmployeeRoles: [],
  companyRoles: [],
};

export const UserReducer = (state = initialState, action: SetUserTypes) => {
  const { type, payload } = action;

  switch (type) {
    case SET_USER_DETAILS:
      return {
        ...state,
        user: payload,
      };
    case SET_USER_STATUS:
      return {
        ...state,
        userStatus: payload,
      };
    case USER_PHONES:
      return {
        ...state,
        userPhones: payload,
      };
    case USER_COMPANIES:
      return {
        ...state,
        userCompanies: payload,
      };
    case FIRST_COMPANY_ID:
      return {
        ...state,
        firstCompanyId: payload,
      };
    case SET_USER_COMPANY:
      return {
        ...state,
        userCompany: payload,
      };
    case SET_USER_VERIFICATION:
      return {
        ...state,
        userVerifications: payload,
      };
    case USER_UPDATE_ERRORS:
      return {
        ...state,
        userUpdateErrors: payload,
      };
    case SET_AVATAR_UPLOADING:
      return {
        ...state,
        avatarUploading: payload,
      };
    case REFRESH_AVATAR:
      return {
        ...state,
        refreshAvatar: payload,
      };
    case SET_USER_PHONE_DETAILS:
      return {
        ...state,
        userPhoneDetails: payload,
      };
    case SET_COMPANY_EMPLOYEE_ROLES:
      return {
        ...state,
        companyEmployeeRoles: payload,
      };
    case SET_COMPANY_ROLES:
      return {
        ...state,
        companyRoles: payload,
      };
    case SET_USER_FEATURE_FLAGS:
      const {
        company_approve: companyApprove,
        rocketscan_damages: rocketscanDamages,
        project_loss_info: projectLossInfo,
        rocket_reports: rocketReports,
        rocket_dry_reports: rocketDryReports,
        'time-tracking': timeTracking,
        'custom-reports': customReports,
        'e-signature': eSignature,
        'rocket-pay': rocketPay,
        'rocket-scope': rocketScope,
        'secondary-company': secondaryCompany,
        'allow-company-wide-edit-notes': allowCompanyWideEditNotes,
        'use-image-processor': imageProcessor,
        // Backend (MONGOOSE-FR-015) emits this as a plain camelCase key. Default false so an
        // absent key fails safe (company stays on the legacy count equipment UI).
        serializedEquipment = false,
      } = payload.values;
      return {
        ...state,
        userFeatureFlagsFetched: true,
        userFeatureFlagsStatus: 'loaded',
        userFeatureFlags: {
          ...state.userFeatureFlags,
          companyApprove,
          rocketscanDamages,
          projectLossInfo,
          rocketReports,
          rocketDryReports,
          timeTracking,
          customReports,
          eSignature,
          rocketPay,
          rocketScope,
          secondaryCompany,
          allowCompanyWideEditNotes,
          imageProcessor,
          serializedEquipment,
        },
      };
    case SET_USER_FEATURE_FLAGS_STATUS:
      return {
        ...state,
        userFeatureFlagsStatus: payload,
      };
    case SET_HIDE_DELETE_BUTTON:
      return {
        ...state,
        userFeatureFlags: {
          ...state.userFeatureFlags,
          hideDeleteButton: payload,
        },
      };
    case SET_CHANGE_PROJECT_COLUMNS:
      return {
        ...state,
        userFeatureFlags: {
          ...state.userFeatureFlags,
          changeProjectColumns: payload,
        },
      };
    case SET_ONLY_SHOW_MY_PROJECTS:
      return {
        ...state,
        userFeatureFlags: {
          ...state.userFeatureFlags,
          onlyShowMyProjects: payload,
        },
      };
    case SET_ALLOW_COMPANY_WIDE_EDIT_NOTES:
      return {
        ...state,
        userFeatureFlags: {
          ...state.userFeatureFlags,
          allowCompanyWideEditNotes: payload,
        },
      };
    default:
      return state;
  }
};
